module.exports = __webpack_public_path__ + "img/m_bg_center.aa06e05e.png";